<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="menuWrap marginBottom20">
        <table>
          <tr v-for="(item, index) in menuTaglist" :key="index + '1'">
            <td :class="{ activeTd: meunTagIndex == itemN.id }" v-for="(itemN, indexn) in item"
              :key="'0' + index + indexn" @click="menuTag(itemN)">
              <a href="javascript:;">{{ itemN.name }}</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="display_flex">
        <div class="leftContent">
          <div class="content_title display_between">
            <div class="content_leftText">{{ content_leftText }}</div>
            <!-- <a href="javascript:;"><img src="/image/index/moreimg.png" class="marginRight5">更多</a> -->
          </div>
          <div v-if="pageCount > 0">
            <div class="listWrapBar" v-for="(item, index) in newsList" :key="'0' + index">
              <div class="imgList marginRight20" @click="clickSpecial(item)">
                <img :src="item.slideShow" />
              </div>
              <a href="javascript:;" class="listItem">
                <div class="listItemTitle" @click="clickSpecial(item)">
                  {{ item.title }}
                </div>
                <div class="display_between opera">
                  <div v-if="item.labelName.length > 0">
                    <span v-bind:class="calculate(indexn)" v-for="(itemN, indexn) in (item.labelName || '').split(',')"
                      :key="'0' + indexn" @click="onsearch(itemN)">
                      {{ itemN }}
                    </span>
                  </div>
                  <div v-else></div>
                  <div class="inforshow">
                    <span class="marginRight20">{{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
                    <span>
                      <img src="/image/index/chakan.png" />
                      <span v-if="item.clickVolume > 0">{{ item.clickVolume }}</span>
                      <span v-else>{{ Math.round(Math.random() * 60) }}</span>
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div v-else style="text-align:center;"><strong>暂无数据</strong></div>
          <!-- 分页器 -->
          <div class="pagination_Wrap" v-if="pageCount > 0">
            <pagination :total="pageCount" :limit="pageSize" :page="pageIndex" @page-change="pageChange"></pagination>
          </div>
        </div>

        <div class="rightVideoList">
          <div class="rightVedioTitle display_between marginBottom20">
            <div class="leftTitle">相关课程推荐</div>
            <div>
              <!-- <a href="javascript:;"><img src="/image/index/moreimg.png" class="marginRight5">更多</a> -->
            </div>
          </div>
          <div class="videoWrap marginBottom30" v-for="(item, index) in courseList" :key="'0' + index"
            @click="courseclick(item)">
            <img class="imgtran" :src="item.acr_PictResUrl" alt="" width="300" height="169" />
            <div class="videoTitle">
              {{ ellipsis(item.title, 18) }}
            </div>
          </div>
          <div class="rightVedioTitle display_between">
            <div class="leftTitle">内容聚类</div>
          </div>
          <div class="display_flex linkRight">
            <ul class="ulList_block">
              <li v-for="(item, index) in NewClusteringList" :key="'0' + index" @click="onsearch(item.labelName)">
                <a href="javascript:;">{{ ellipsis(item.labelName, 4) }}({{ item.count }})</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import breadcrumbPage from '../home/breadcrumbPage';
import lodash from 'lodash';
import Pagination from '../components/page/pagination.vue';
export default {
  name: 'Inforlist',
  data() {
    return {
      // 页数激活index
      pageIndex: 1,
      // // 总页数
      // pageAll: 1,
      // 顶部菜单切换列表
      menuTaglist: [],
      // 顶部切换index
      meunTagIndex: 0, //'000',
      apiData: {
        taglist: {},
        baseData: {},
        courseData: {},
        contentData: {}
      },
      /**tianlianpei */
      content_leftText: '',
      pageSize: 10,
      pageCount: 0,
      keywork: '',
      selname: '',
      childname: '',
      selColumnList: [], //下拉栏目
      selchildColumnList: [],
      childColumnList: [],
      newsList: [],
      newCount: 0,
      NewClusteringList: [], //咨询内容聚类
      strID: '',
      labelName: '',
      courseList: [], //推荐课程
      columnPid: 0,
      columnid: 0,
      colflag: false,
      menuname: '', //菜单名称
      crumbFirsturl: '',
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
      matched: []
    };
  },
  components: {
    breadcrumbPage,
    Pagination
  },
  created() {
    this.matched = this.$route.matched;
    this.meunTagIndex = this.$route.query.cid;
    this.content_leftText = this.$route.query.title;
    this.columnPid = this.$route.query.pid;
    this.columnid = this.$route.query.cid;
    localStorage.removeItem('Inforlist_param_' + this.meunTagIndex);
    this.matched.forEach(element => {
      if (element.name == this.$route.name) element.meta.breadcrumbTitle = this.content_leftText;
    });
    this.GetNewsList(this.$route.query.pid, this.$route.query.cid);
    this.GetColumsInfoAllList();
    this.GetNewClustering(Number(this.$route.query.pid), 0);
  },
  watch: {
    $route: function () {
      if (this.$route.query.title && this.$route.query.title != this.content_leftText) {
        this.matched = this.$route.matched;
        this.meunTagIndex = this.$route.query.cid;
        this.content_leftText = this.$route.query.title;
        this.columnPid = this.$route.query.pid;
        this.columnid = this.$route.query.cid;
        localStorage.removeItem('Inforlist_param_' + this.meunTagIndex);
        this.matched.forEach(element => {
          if (element.name == this.$route.name) element.meta.breadcrumbTitle = this.content_leftText;
        });
        this.GetNewsList(this.$route.query.pid, this.$route.query.cid);
        this.GetColumsInfoAllList();
      }
    }
  },
  methods: {
    calculate(index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    menuTag(itemN) {
      if (itemN.id == 71) {
        window.location.href = this.httphelper.IsDebugGP519() + '/home/specialRecomme?id=167';
      }
      this.pageIndex = 1;
      this.meunTagIndex = itemN.id; //'0' + index + indexn
      this.content_leftText = itemN.name;
      this.matched.forEach(element => {
        if (element.name == this.$route.name) element.meta.breadcrumbTitle = this.content_leftText;
      });
      this.GetNewsList(this.$route.query.pid, itemN.id);
    },
    /**点击分页事件 */
    pageChange(page) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetNewsList(this.columnPid, this.meunTagIndex);
    },

    /**tianlianpei */

    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**获取新闻列表 */
    GetNewsList(pcid, cid) {
      let _this = this;
      _this.columnPid = pcid;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: _this.keywork,
          id: -1,
          parentID: Number(pcid),
          column_Type: Number(cid),
          pageIndex: Number(_this.pageIndex),
          pageSize: Number(_this.pageSize)
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.pageCount = res.data.data.pageCount;
            _this.newsList = [];
            // _this.newCount = 0
            let newInfoViewsList = res.data.data.gpSiteNewInfoViewsViews;
            if (newInfoViewsList != null && newInfoViewsList.length > 0) {
              _this.newsList = newInfoViewsList;
            }
          }
        });
    },

    /**新闻的点击事件 */
    clickNew(info) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        const { href } = this.$router.resolve({
          path: '/home/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    clickSpecial(info) {
      if (Object.keys(info.address).length == 0) {
        var param = { pid: this.$route.query.pid, title: this.content_leftText, cid: this.meunTagIndex, goroutename: this.$route.name };
        localStorage.setItem('Inforlist_param_' + this.meunTagIndex, JSON.stringify(param));
        let pathstr = '/home/inforDetails?';
        if (this.$route.path.search('/grassheal/Inforlist') > -1) {
          pathstr = '/grassheal/Inforlist/inforDetails?';
        } else if (this.$route.path.search('/disciconstruc/Inforlist') > -1) {
          pathstr = '/disciconstruc/Inforlist/inforDetails?';
        } else if (this.$route.path.search('/journal/Inforlist') > -1) {
          pathstr = '/journal/Inforlist/inforDetails?';
        } else if (this.$route.path.search('/home/Inforlist') > -1) {
          pathstr = '/home/Inforlist/inforDetails?';
        }
        const { href } = this.$router.resolve({
          path: pathstr,
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        let urlstr = info.address;
        let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
        if (urlstr.search('specialRecomme') > -1) {
          const { href } = this.$router.resolve({
            path: '/home/specialRecomme' + param
          });
          window.open(href, '_blank');
        } else if (urlstr.search('specialproject') > -1) {
          const { href } = this.$router.resolve({
            path: '/enterprise/qyhome' + param
          });
          window.open(href, '_blank');
        } else if (urlstr.search('magazine/magazinejournal/magazinejournaldetail') > -1) {
          const { href } = this.$router.resolve({
            path: '/journal/magazinejournal/magazinejournaldetail' + param
          });
          window.open(href, '_blank');
        } else {
          window.open(info.address, '_blank');
        }
      }
    },
    /**获取栏目名称 */
    GetColumsInfoAllList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          _this.crumbFirsturl = '';
          if (res.data.code == 200) {
            _this.selColumnList = []
            _this.selchildColumnList = []
            _this.childColumnList = []
            res.data.data.forEach(item => {
              if (item.parentid == '0') {
                //一级菜单
                _this.selColumnList.push(item);
                if (item.id == _this.selname) {
                  _this.menuname = item.name;
                  if (item.id == 32) {
                    _this.crumbFirsturl = '/home';
                  } else if (item.id == 35) {
                    _this.crumbFirsturl = '/grassheal';
                  } else if (item.id == 36) {
                    _this.crumbFirsturl = '/magazine';
                  } else if (item.id == 37) {
                    _this.crumbFirsturl = '/disciconstruc';
                  }
                }
              } else {
                _this.selchildColumnList.push(item);
              }
            });
            let data = _this.selchildColumnList.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              if (item.parentid == _this.columnPid && item.status == 1) {
                //一级菜单
                _this.childColumnList.push(item);
                _this.menuTaglist = lodash.chunk(_this.childColumnList, 7);
              }
            });
          }
        });
    },
    /**获取内容聚类数据 */
    GetNewClustering(columnPid, columnid) {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetNewInfoList', {
          parentID: columnPid,
          childrenID: columnid
        })
        .then(res => {
          if (res.data.code == 200) {
            let newInfoViewsList = res.data.data.gpSiteNewInfoViewsViews;
            if (newInfoViewsList != null && newInfoViewsList.length > 0) {
              _this.strID = '';
              _this.NewClusteringList = [];
              newInfoViewsList.forEach(element => {
                if (!_this.strID.includes(element.id)) {
                  _this.strID += element.id + ',';
                }
              });
              _this.strID = _this.strID.substring(0, this.strID.length - 1);
              _this.httphelper
                .post('/api/NewApi/GetNewClustering', {
                  ids: _this.strID
                })
                .then(res => {
                  if (res.data.code == 200) {
                    _this.NewClusteringList = res.data.data;
                  }
                });
              _this.GetCourseRecommendPageList();
            }
          }
        });
    },
    /**相关课程推荐 */
    GetCourseRecommendPageList() {
      let _this = this;
      _this.labelName = '';
      _this.courseList = [];
      _this.NewClusteringList.forEach(element => {
        this.labelName += element.labelName + ',';
      });
      this.labelName = this.labelName.substring(0, this.labelName.length - 1);
      _this.httphelper
        .post('/api/ArticleApi/GetCourseRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: _this.labelName,
          recommendNumber: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.courseList = res.data.data;
          }
        });
    },

    /**课程跳转 */
    courseclick(item) {
      let id = item.courseInfoId == 0 ? item.id : item.courseInfoId;
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    },
    onsearch(keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    }
  }
};
</script>

<style scoped>
.content {
  padding-top: 40px;
  flex: 1;
}

.menuWrap table {
  border-collapse: collapse;
  width: 100%;
}

.menuWrap table td {
  border: 1px solid #dee2e6;
  height: 38px;
  text-align: center;
  cursor: pointer;
  width: 172px;
}

.menuWrap table td a {
  display: inline-block;
  width: 100%;
  height: 100%;
  line-height: 38px;
}

.activeTd a {
  background-color: #0b8686;
  color: #fff;
}

.leftContent {
  flex: 1;
}

.content_title {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

.content_leftText {
  font-size: 20px;
  font-weight: bold;
  color: #0b8686;
  border-bottom: 1px solid #0b8686;
}

.content_title a {
  color: #999;
}

/* 列表 */
.listWrapBar {
  display: flex;
  border-bottom: 1px solid #ddd;
  padding: 20px 0;
}

.imgList {
  width: 150px;
}

.imgList img {
  width: 100%;
}

.listItem {
  flex: 1;
}

.listItem:last-child {
  border-bottom: none;
}

.listItemTitle {
  font-size: 18px;
  margin-bottom: 10px;
  position: relative;
}

.listItemSub {
  font-size: 16px;
  color: #ccc;
}

.opera {
  margin-top: 20px;
}

.gree_block,
.red_block,
.blue_block {
  display: inline-block;
  padding: 4px 8px;
  font-size: 12px;
  margin-right: 5px;
}

.gree_block {
  border: 1px solid #469a97;
  color: #469a97;
}

.red_block {
  border: 1px solid #cc6d6e;
  color: #cc6d6e;
}

.blue_block {
  border: 1px solid #417393;
  color: #417393;
}

.inforshow {
  color: #ccc;
}

/* 右侧样式设置 */
.rightVideoList {
  width: 310px;
  margin-left: 50px;
}

/* 右面视频列表样式 */

.rightVedioTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ddd;
}

.leftTitle {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #333;
}

.videoWrap video {
  width: 100%;
}

.videoTitle {
  font-size: 16px;
  margin-top: 12px;
}

.linkRight li {
  margin-bottom: 20px;
}
</style>
